import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { BsgGlove } from '../../api/models';

export type TABLE_TYPE = Table<BsgGlove>;

export const TABLE = 'bsgGlove';
const SCHEMA = 'bsgGloveId, sortId';

class BsgGloveDatabase implements DataRepository<BsgGlove> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<BsgGlove | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: BsgGlove, key: Key): Promise<BsgGlove> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: BsgGlove[]): Promise<BsgGlove[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<BsgGlove[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const BsgGloveDB = new BsgGloveDatabase(db);
